import { render, staticRenderFns } from "./InspectionProjectDetail.vue?vue&type=template&id=6b48a524&scoped=true&"
import script from "./InspectionProjectDetail.vue?vue&type=script&lang=ts&"
export * from "./InspectionProjectDetail.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionProjectDetail.vue?vue&type=style&index=0&id=6b48a524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b48a524",
  null
  
)

export default component.exports